<template>
    <table class="ot-table ot-table-dashboard ot-table-dashboard-compressed">
        <thead class="OToverHeader">
            <tr>
                <th class="OTborder-right p20 OTtableTriggerInfo">
                    <span
                        class="OTicon-extend-info"
                        v-on:click="toggleShowExtraAll()"
                        v-bind:class="{ 'OTicon-close-info': showExtra }"
                    ></span>
                    <span v-show="showExtra">Hide Infos</span>
                    <span v-show="!showExtra">Extend Info</span>
                </th>
                <th colspan="4" class="p80">Documents</th>
                <th colspan="4" class="p80 OTcenterCell">Events</th>
            </tr>
        </thead>
        <thead>
            <tr>
                <th class="OTborder-right p20">Info</th>
                <th class="p20">Submitted</th>
                <th class="p20">Processed</th>
                <th class="p20">Enriched</th>
                <th class="p20">Persisted</th>
                <th class="p20">
                    <span class="ot-icon-levels-critical" title="Critical"></span>
                </th>
                <th class="p20">
                    <span class="ot-icon-levels-error" title="Error"></span>
                </th>
                <th class="p20">
                    <span class="ot-icon-levels-information" title="Information"></span>
                </th>
                <th class="p20">
                    <span class="ot-icon-levels-warning" title="Warning"></span>
                </th>
            </tr>
        </thead>
        <tbody v-if="componentIds.length > 0">
            <PipelineRow
                v-for="componentId in componentIds"
                :componentId="componentId"
                :key="componentId"
                :clusterId="clusterId"
            ></PipelineRow>
        </tbody>
        <tbody v-else>
            <tr>
                <td
                    colspan="5"
                    class="OTtableMessage"
                >No component data is available yet for this cluster.</td>
            </tr>
        </tbody>
        <tfoot>
            <tr v-if="componentIds.length > 0">
                <td class="OTborder-right p20">Total</td>

                <td class="p20">{{ totalSubmitted }}</td>
                <td class="p20">{{ totalProcessed }}</td>
                <td class="p20">{{ totalEnriched }}</td>
                <td class="p20">{{ totalPersisted }}</td>
                <td class="p20 ErrorColor">{{totalCritical }}</td>
                <td class="p20 ErrorColor">{{totalError }}</td>
                <td class="p20 InfoColor">{{ totalInfo }}</td>
                <td class="OTborder-right p20 WarningColor">{{ totalWarning }}</td>
            </tr>
        </tfoot>
    </table>
</template>

<script>
import componentTablesMixin from "../../../mixins/componentsTable.js";
import PipelineRow from "./PipelineRow.vue";
import { mapTotals } from "../../../storeUtils/mapDatums.js";

const datumColumns = {
    queued: "Queued",
    submitted: "Submitted",
    processed: "Processed",
    enriched: "Enriched",
    persisted: "Persisted",
    info: "Info",
    warning: "Warnings",
    error: "Errors",
    critical: "Critical"
};

export default {
    mixins: [componentTablesMixin],
    props: ["clusterId"],
    components: {
        PipelineRow
    },
    data() {
        return {
            showExtra: false
        };
    },
    computed: {
        ...mapTotals(Object.keys(datumColumns))
    },

    methods: {
        toggleShowExtraAll() {
            this.$emit("show-extra-info");
        }
    }
};
</script>
